/**
 * Container for {@link LineItemDisplayRowView}.
 *
 * This row owns no logic on its own — it forwards pre-bound handlers
 * from its parent ({@link LineItemRowContainer}) straight to the view.
 * A trivial container exists only to satisfy the project's enforced
 * Container/View component-directory structure.
 * @module features/contracts/components/LineItemDisplayRow/LineItemDisplayRowContainer
 */

import React, { memo } from "react";

import LineItemDisplayRowView, {
  type LineItemDisplayRowViewProps,
} from "./LineItemDisplayRowView";

/** Props for {@link LineItemDisplayRowContainer}. */
export type LineItemDisplayRowContainerProps = LineItemDisplayRowViewProps;

/**
 * Pass-through container for {@link LineItemDisplayRowView}.
 * @param props - Container props
 * @returns The rendered view
 */
function LineItemDisplayRowContainer(props: LineItemDisplayRowContainerProps) {
  return <LineItemDisplayRowView {...props} />;
}

LineItemDisplayRowContainer.displayName = "LineItemDisplayRowContainer";

export default memo(LineItemDisplayRowContainer);
